import { TakenCard, AvailableCard, SavedCardData } from '../../types';

type useSavedCardActionsReturn = {
  saveLoggedOutInteraction: (card: TakenCard | AvailableCard) => void;
};

export const useCardInteractedLoggedOut = (): useSavedCardActionsReturn => {
  const saveLoggedOutInteraction = (card: TakenCard | AvailableCard): void => {
    const rawInteractedCards = JSON.parse(
      localStorage.getItem('dm-interacted-cards-logged-out') || '[]'
    );
    const interactedCards: SavedCardData[] = Array.isArray(rawInteractedCards)
      ? rawInteractedCards
      : [];

    if (!card.data.id || !card.data.jobTitle) {
      return;
    }

    const savedCard: SavedCardData = {
      type: card.type,
      updatedAt: new Date(),
      data: {
        id: card.data.id,
        jobSlug: card.data.jobSlug,
        title: card.data.jobTitle || '',
        companyName:
          card.data.company?.companyName ||
          card.data.fallbackCompany?.companyName ||
          '',
        companyLogoUrl: card.data.company?.logos?.logo256px || null,
        location: card.data.location || '',
        urn: card.data.urn || '',
      },
    };

    if (!interactedCards.some((c) => c.data.id === savedCard.data.id)) {
      localStorage.setItem(
        'dm-interacted-cards-logged-out',
        JSON.stringify([...interactedCards, savedCard])
      );
    }
  };

  return {
    saveLoggedOutInteraction,
  };
};
